module.exports = `
<div class="wishlist-content">
  <div class="mb-5">
    <div class="mb-4 wish-title">Wish List <span>({{ totalCount }})</span></div>
    <div class="h4">This is the selection of items you like most</div>
  </div>
  <favoriteTable :data="data" v-if="dataIsLoad" v-on:delete="cancelFavorite"></favoriteTable>
  <Pagination v-if="dataIsLoad" :total-page="totalPage"></Pagination>
</div>
`;
